module.exports = __webpack_public_path__ + "static/media/36.51edf631.jpg";